import React, { useEffect, useRef } from "react";
import { Wrapper, Container } from "../styles/components/Global/Global";
import {
  GalleryWrapper,
  GalleryContainer,
  ImageWrapper,
  ImageContainer,
  Image,
} from "../styles/components/Galleries/Horizontal";
import {
  SceneContainer,
  Scene,
  SceneChildren,
} from "../styles/components/Global/Global";
import animations from "./Animations";

const GalleryHorizontal = ({ gallery }) => {
  const { name, media } = gallery;
  const containerRef = useRef(null);
  const galleryContainer = useRef(null);

  useEffect(() => {
    setTimeout(() => {
      animations.galleryHorizontal(
        containerRef.current,
        galleryContainer.current
      );
    }, 1000);
  }, []);

  return (
    <Wrapper ref={containerRef} className="fullwrapper" $height="100vh">
      <SceneContainer id={`${name}-scene`}>
        <Scene className="scene" />
        <SceneChildren>
          <Container $justify="flex-start" $flex>
            <GalleryWrapper>
              <GalleryContainer ref={galleryContainer}>
                {media?.map((image, i) => (
                  <ImageWrapper
                    key={i}
                    className="image-scroll"
                    $align={image.align}
                  >
                    <ImageContainer>
                      <Image src={image.source} $margin={image.margin} />
                    </ImageContainer>
                  </ImageWrapper>
                ))}
              </GalleryContainer>
            </GalleryWrapper>
          </Container>
        </SceneChildren>
      </SceneContainer>
    </Wrapper>
  );
};

export default GalleryHorizontal;
